// Application Shell
import {Shell} from '@/entryPoints/b2c/shell';

// Vue components
import SectionHeader from '@/components/SectionHeader';
import Heading from '@/components/Heading';
import RssBlogFeed from '@/components/blog-feed-container/RssBlogFeed';
import ElpLocallyWidget from '@/components/elp-widgets/ElpLocallyWidget';
import ElpRentBikeWidget from '@/components/elp-widgets/ElpRentBikeWidget';
import VueScrollTo from 'vue-scrollto';
// Legacy Plugins
import '@/vendor/owl.carousel.min.js';
import '@/vendor/owl.carousel.plugins.js';
import '@/vendor/acc.storefinder';

// Legacy Modules
import slider from '@/modules/slider';

// Styling
import '@sassRoot/entryPoints/b2c/elp.scss';
import productTile from '@/modules/ProductTile';

class Elp extends Shell {
  loadPlugins() {
    // Load common plugins from Shell
    super.loadPlugins();
    this.loadScrollTo();
  }
  loadScrollTo() {
    this.vue.use(VueScrollTo, {
      container: 'body',
      duration: 500,
      easing:'ease',
      offset: -100,
      force: true,
      cancelable: true,
      onStart: false,
      onDone: false,
      onCancel: false,
      x: false,
      y: true,
    });
  }
}

const elp = new Elp({
  SectionHeader,
  Heading,
  ElpLocallyWidget,
  RssBlogFeed,
  ElpRentBikeWidget,
});
elp.initializeVue();

// Legacy foundation initialization
$(document).foundation();

$(document).ready(() => {
  elp.globalDocumentReadyInits();
});

$(window).on('load', () => {
  elp.globalOnLoadInits();

  // setting up owl sliders
  const sliders = $('[data-owl-slider]');
  window.sliderRefs = [];
  sliders.each((i, s) => {
    window.sliderRefs.push(slider($(s)));
  });

  // Color Swatches for carousels (More Options, etc)
  if ($('.product-tile').length) {
    productTile($(document));
  }
});
